import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useDocumentTitle } from '@hooks';
import Background from '../../components/Background/Background';
import SettingsLabel from '../../components/SettingsLabel/SettingsLabel';
import CursorControl from './CursorControl/CursorControl';
import data from './data';
import classes from './CssCursors.styles.less';
export default function CssCursors() {
    useDocumentTitle('CSS cursor properties');
    const controls = data.map((group) => {
        const values = group.data.map((value) => (_jsx(CursorControl, { value: value, className: classes.control }, value)));
        return (_jsxs("div", { className: classes.group, children: [_jsx(SettingsLabel, { className: classes.title, children: group.title }), _jsx("div", { className: classes.controls, children: values })] }, group.title));
    });
    return _jsx(Background, { className: classes.wrapper, children: controls });
}
